import React, { type FC } from 'react'

import { objectEntries } from '../../../../utils'

import { Capability, type CybusDetailedVolume, CybusLogSource, Translation } from '../../../../domain'

import { Table } from '../../common'
import Logs, { useAreLogsAvailable } from '../../Logs'
import { Tab, Tabs } from '../../Tabs'

export const Content: FC<Readonly<{ resource: CybusDetailedVolume }>> = ({ resource: { id, labels } }) => {
    const available = useAreLogsAvailable(CybusLogSource.VOLUME, id)

    return (
        <Tabs>
            <Tab title={Translation.VOLUME_LOGS} disabled={!available} requiredCapabilities={[Capability.LOGS_READ]}>
                <Logs id={id} type={CybusLogSource.VOLUME} />
            </Tab>
            <Tab title={Translation.LABEL}>
                <Table
                    data={objectEntries(labels).map(([name, value]) => ({ name, value }))}
                    columns={{ name: { label: Translation.NAME, sort: true }, value: { label: Translation.VALUE } }}
                />
            </Tab>
        </Tabs>
    )
}
